import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { InboxOutlined } from '@ant-design/icons'
import { getCookie } from 'helper/cookie'
import { getListSupportNeedByProjectId, getResultSupportNeed } from 'api/Project/supportneed'
import moment from 'moment'
import 'styleLess/signature/overviewAll.scss'
import { Card, Col, Layout } from 'antd'
import { Content } from 'antd/lib/layout/layout'
import ModalEdit from 'common/SupportNeed/ModalEdit'
const Container = styled.div``
const LayoutAvatar = styled.div``
const LayoutUser = styled.div``
const SupportStyle = styled.div`
  display: flex;
  flex-direction: column;
`
const initalState = {
  data: [],
  isLoading: true,
}
const Supportneed = (props) => {
  const { idProject, valueRole, mainRoleUser, dataProject } = props
  const token = getCookie('access_token_admin')
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const [dataListSPN, setDataListSPN] = useState(initalState.data)
  // const [dataSupportNeed, setDataSupportNeed] = useState(initalState.data)
  const [dataEdit, setDataEdit] = useState(initalState.data)
  const [modalState, setModalState] = useState(false)
  const [disableModal, setDisableModal] = useState(false)

  useEffect(() => {
    if (mainRoleUser === '9') {
      setDisableModal(true)
    }
    else if (dataEdit.support_status === 'Done' || dataEdit.support_status === 'Cancel') {
      setDisableModal(true)
    }
    else {
      if ((valueRole.role_name === 'Project Member')) {
        // console.log('M')
        setDisableModal(true)
      } else if (
        (valueRole.role_name === 'Project Leader') ||
        (valueRole.role_name === 'Project Sponsor') ||
        (valueRole.role_name === 'Project PMO')) {
        // console.log('L S P')
        setDisableModal(false)
      } else {
        // console.log('other')
        setDisableModal(true)
      }
    }
  }, [valueRole, dataEdit])

  const getListData = async () => {
    await getListSupportNeedByProjectId({
      id: idProject,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          await setDataListSPN([])
          await setIsLoading(false)
          return true
        }
        if (status === 200) {
          await setDataListSPN(data)
          await setIsLoading(false)
        } else {
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setIsLoading(false)
        console.error(error)
      })
  }

  const getSupportNeed = async () => {
    getResultSupportNeed({
      project_id: parseInt(idProject),
      sprintflow_id: 0,
      taskinbox: 'N',
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (status === 200) {
          // setDataSupportNeed(data)
          // setDataEdit(data)
        }
        else {
          // setDataSupportNeed([])
          // setDataEdit([])
          return true
        }
      })
      .catch((error) => {
        // setDataSupportNeed([])
        // setDataEdit([])
        console.error(error)
      })
  }

  useEffect(() => {
    if (token) {
      getListData()
      getSupportNeed()
    }
  }, [token])

  const playState = () => {
    if (dataListSPN.length > 0) {
      return Normalstate()
    } else {
      return Emptystate()
    }
  }

  const EditSupportNeed = (value) => {
    setModalState(true)
    setDataEdit(value)
  }
  const Normalstate = () => {
    return dataListSPN.map((item) => {
      return (
        <Container className="sub-container-overview" onClick={() => { EditSupportNeed(item) }}>
          <LayoutAvatar className="layoutAvatar">
            <img className="imageStyle" src={item.account_display}></img>
          </LayoutAvatar>
          <LayoutUser className="layoutUser">
            <div style={{ display: 'grid', maxWidth: '80%' }}>
              <p className="request cutter-text-line-1">{item.description}</p>
            </div>
            <div style={{ marginBottom: 2 }}>
              <span className="small">{item.account_name}</span>
            </div>
            <div className="date-row">
              <span className="small date">
                {moment(item.created_at).format('DD MMM YYYY')}
              </span>
              <div className="status-row">
                <div className="tag-li"></div>
                <p className="small font-li">{item.support_type_name}</p>
                <div
                  style={{
                    minWidth: 'fit-content',
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <div
                    className={`Status  ${item.support_status === 'Open'
                      ? 'status-Open'
                      : item.support_status === 'Done'
                        ? 'status-Done'
                        : item.support_status === 'In Progress'
                          ? 'status-InProgress'
                          : item.support_status === 'Cancel'
                            ? 'status-Cancel'
                            : 'status-Done-Delayed'
                      }`}
                    style={{ marginTop: -6 }}
                  >
                    <p className="font-status">{item.support_status}</p>
                  </div>
                </div>
              </div>
            </div>
          </LayoutUser>
        </Container >
      )
    })
  }
  const Emptystate = () => {
    return (
      <div className="emytystate">
        <InboxOutlined className="inbox" />
        <p>No Support Need</p>
      </div>
    )
  }

  return (
    <SupportStyle className="supportStyle-container">
      <h3 className="title-sup">Support Need</h3>
      <div className="box-support">{playState()}</div>
      <ModalEdit
        dataProject={dataProject}
        valueRole={valueRole}
        modalState={modalState}
        setModalState={setModalState}
        idProject={idProject}
        dataEdit={dataEdit}
        idEditPRJ={idProject}
        getListData={getListData}
        disableModal={disableModal}
      />
    </SupportStyle>
  )
}

export default Supportneed
